var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "sidebar__mobile",
      attrs: {
        id: "sidebar__main",
        tabindex: "0",
        role: "dialog",
        "aria-labelledby": "filterSiderbarLabel",
        "aria-hidden": "true",
      },
      on: {
        focus: function ($event) {
          return _vm.selectedDown()
        },
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          )
            return null
          $event.preventDefault()
          return _vm.closeNav()
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "sidebar__filter sidebar__header",
          class: { sidebar__toggle: _vm.toggleFilter },
          attrs: { id: "sideBarHeader" },
        },
        [
          _c("span", { staticClass: "text-upper sidebar__headline" }, [
            _vm._v(
              "\n            " + _vm._s(_vm.trans("FORM_FILTER")) + "\n        "
            ),
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              attrs: {
                type: "button",
                "data-gtm": "sidebar__close",
                "data-pendo": "sidebar__close",
                "aria-label": "Close sidebar",
                "aria-controls": "close sidebar",
              },
              on: {
                click: function ($event) {
                  return _vm.closeNav()
                },
              },
            },
            [
              _c(
                "svg",
                {
                  staticClass: "sidebar__icon sidebar__icon--cross",
                  attrs: {
                    width: "20px",
                    height: "20px",
                    "aria-hidden": "true",
                  },
                },
                [_c("use", { attrs: { href: "#iconCrossBold" } })]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c("SidebarFilter", {
        on: {
          "selected-accuracy": _vm.emittedAccuracyValue,
          "selected-contentTypes": _vm.emittedContentTypeValue,
          "selected-region": _vm.emittedRegionValue,
          "selected-countries": _vm.emittedCountriesValue,
          "selected-regionalBoost": _vm.emittedRegionalBoostValue,
          "selected-interval": _vm.emittedIntervalValue,
          "selected-archive": _vm.emittedArchiveValue,
          "selected-sort": _vm.emittedSortValue,
          "selected-category": _vm.emittedCategoryValue,
          "selected-sub-category": _vm.emittedSubCategoryValue,
          "selected-language": _vm.emittedLanguageValue,
          "excluded-regions": _vm.emittedExcludedRegions,
          "is-filter-open": _vm.filterIsOpen,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar__footer" }, [
        _c(
          "button",
          {
            staticClass: "sidebar__button sidebar__button--reset",
            attrs: {
              type: "button",
              "aria-controls": "sidebarSearchOptions",
              "data-gtm": "sidebar__Filter--reset",
              "data-pendo": "sidebar__Filter--reset",
              "aria-label": "Apply sidebar filters",
            },
            on: {
              click: function ($event) {
                return _vm.resetFilter()
              },
            },
          },
          [
            _c(
              "svg",
              {
                staticClass: "sidebar__icon sidebar__icon--reset",
                attrs: { "aria-hidden": "true" },
              },
              [_c("use", { attrs: { href: "#iconArrowClockwiseBold" } })]
            ),
            _vm._v(
              "\n            " + _vm._s(_vm.trans("RESET_ALL")) + "\n        "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "sidebar__button sidebar__button--apply",
            attrs: {
              disabled: !_vm.changed,
              type: "button",
              "aria-controls": "sidebarSearchOptions",
              "data-gtm": "sidebar__Filter--apply",
              "data-pendo": "sidebar__Filter--apply",
              "aria-label": "Reset sidebar filters",
            },
            on: {
              click: function ($event) {
                return _vm.applyFilter()
              },
            },
          },
          [
            _vm._v(
              "\n            " +
                _vm._s(_vm.trans("APPLY_FILTER")) +
                "\n        "
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }